import { useContext } from "react";
import { AuthContext, DefaultProviderProps } from "../contexts/AuthContext";

export const useAuth = (): DefaultProviderProps => useContext(AuthContext);
